import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#06B6D4' },
    secondary: { main: '#7dd3fc' },
    background: {
      default: '#060c14',
      paper: '#0c1828',
    },
    text: {
      primary: '#e2e8f0',
      secondary: '#8899b4',
    },
    divider: 'rgba(255,255,255,0.08)',
    info: { main: '#0EA5E9' },
    success: { main: '#22c55e' },
    warning: { main: '#F59E0B' },
    error: { main: '#EF4444' },
  },
  shape: { borderRadius: 16 },
  typography: {
    fontFamily:
      '"Inter Variable", Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif',
    h1: { fontWeight: 900, letterSpacing: -1.5 },
    h2: { fontWeight: 900, letterSpacing: -1 },
    h3: { fontWeight: 800, letterSpacing: -0.5 },
    h4: { fontWeight: 800, letterSpacing: -0.3 },
    subtitle1: { fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 700 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#060c14',
          color: '#e2e8f0',
        },
        '::selection': {
          backgroundColor: 'rgba(6, 182, 212, 0.28)',
        },
        a: {
          color: '#06B6D4',
          textDecoration: 'none',
        },
        'a:hover': {
          textDecoration: 'underline',
        },
        '::-webkit-scrollbar': {
          width: 8,
        },
        '::-webkit-scrollbar-track': {
          background: '#060c14',
        },
        '::-webkit-scrollbar-thumb': {
          background: 'rgba(255,255,255,0.1)',
          borderRadius: 4,
        },
      },
    },
    MuiAppBar: {
      defaultProps: { color: 'default', elevation: 0, position: 'sticky' },
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(6, 12, 20, 0.85)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: { minHeight: 60 },
      },
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: '#0c1828',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          border: '1px solid rgba(255,255,255,0.07)',
          backgroundColor: '#0c1828',
          boxShadow: '0 4px 24px rgba(0,0,0,0.4)',
          transition: 'transform .2s ease, border-color .2s ease',
          '&:hover': {
            transform: 'translateY(-2px)',
            borderColor: 'rgba(6,182,212,0.3)',
          },
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 12,
          fontWeight: 700,
        },
        containedPrimary: {
          color: '#060c14',
          '&:hover': { backgroundColor: '#22d3ee' },
        },
        containedSecondary: {
          color: '#060c14',
        },
        outlined: {
          borderWidth: 1.5,
          '&:hover': { borderWidth: 1.5, backgroundColor: 'rgba(6,182,212,0.08)' },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 10, fontWeight: 700 },
        filled: {
          backgroundColor: 'rgba(6,182,212,0.15)',
          color: '#06B6D4',
        },
        outlined: {
          borderColor: 'rgba(255,255,255,0.12)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: 'rgba(255,255,255,0.04)',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255,255,255,0.1)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255,255,255,0.2)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#06B6D4',
            boxShadow: '0 0 0 3px rgba(6,182,212,0.15)',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        outlined: { borderRadius: 12 },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: { borderRadius: 8 },
      },
    },
    MuiTooltip: {
      defaultProps: { arrow: true },
      styleOverrides: {
        tooltip: {
          fontSize: 12,
          borderRadius: 8,
          backgroundColor: '#1a2540',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: { borderColor: 'rgba(255,255,255,0.08)' },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: { fontWeight: 600 },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          borderColor: 'rgba(255,255,255,0.1)',
          color: '#8899b4',
          '&.Mui-selected': {
            backgroundColor: 'rgba(6,182,212,0.15)',
            borderColor: '#06B6D4',
            color: '#06B6D4',
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
  },
});

export default theme;
